import React from "react";

export const Header = () => {
  return <h2 className="header">Expense Tracker</h2>;
};
